export enum GDDBaseTemperature {
  base0 = 'base0',
  base10 = 'base10'
}

export const metricGDDBaseTemperatureLabels: { [key in GDDBaseTemperature]: string } = {
  [GDDBaseTemperature.base0]: '0',
  [GDDBaseTemperature.base10]: '10'
};

export const imperialGDDBaseTemperatureLabels: { [key in GDDBaseTemperature]: string } = {
  [GDDBaseTemperature.base0]: '32',
  [GDDBaseTemperature.base10]: '50'
};

export enum GDDExtremaTemperature {
  lowest = 'lowest',
  highest = 'highest'
}

export const gddExtremaTemperatureTranslation: { [key in GDDExtremaTemperature]: string } = {
  [GDDExtremaTemperature.lowest]: 'CHEMICAL-PAGE.GDD.EXTREMA-OPTIONS.LOWEST',
  [GDDExtremaTemperature.highest]: 'CHEMICAL-PAGE.GDD.EXTREMA-OPTIONS.HIGHEST'
};

export enum GDDPestOption {
  crabgrass = 'crabgrass',
  abg = 'abg',
  none = 'none'
}

export const gddPestOptionsTranslation: { [key in GDDPestOption]: string } = {
  [GDDPestOption.crabgrass]: 'CHEMICAL-PAGE.GDD.PEST-OPTIONS.CRABGRASS',
  [GDDPestOption.abg]: 'CHEMICAL-PAGE.GDD.PEST-OPTIONS.ABG',
  [GDDPestOption.none]: 'GLOBAL.NONE'
};

export const gddPestOptionsDescription: { [key in GDDPestOption]: string } = {
  [GDDPestOption.crabgrass]: 'CHEMICAL-PAGE.GDD.PEST-OPTIONS.CRABGRASS',
  [GDDPestOption.abg]: 'CHEMICAL-PAGE.GDD.PEST-OPTIONS-DESCRIPTION.ABG',
  [GDDPestOption.none]: 'GLOBAL.NONE'
};

export const crabgrassPestModelSuffix: { [key in GDDBaseTemperature]: string } = {
  [GDDBaseTemperature.base0]: 'CHEMICAL-PAGE.GDD.CRABGRASS-MODEL-SUFFIX.PRE',
  [GDDBaseTemperature.base10]: 'CHEMICAL-PAGE.GDD.CRABGRASS-MODEL-SUFFIX.POST'
};

export enum GddModelStatus {
  isReady = 'isReady',
  isDisabled = 'isDisabled',
  isProcessing = 'isProcessing'
}

export const baseTemperatureToGddModelMap: {
  [key in GDDBaseTemperature]: 'cumulativeGddBase0' | 'cumulativeGddBase10';
} = {
  [GDDBaseTemperature.base0]: 'cumulativeGddBase0',
  [GDDBaseTemperature.base10]: 'cumulativeGddBase10'
};
